function Alert(content, type) {
  const duration = 3000;
  let alert = document.createElement('div');
  alert.classList.add("alert");
  if ( type !== undefined ) {
    alert.classList.add("alert-"+type);
  }
  alert.textContent = content;
  document.body.appendChild(alert);

  setTimeout((function() {
    alert.classList.add("alert--show");
  }), 100);
  setTimeout((function() {
    alert.classList.add("alert--dismiss");
  }), duration);
};

export default Alert;



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/Alert.js